import Support from '../../../assets/images/support.svg';
import Certified from '../../../assets/images/certified.svg';
import Personalized from '../../../assets/images/personalized.svg';
import Compassion from '../../../assets/images/compassion.svg';
import nirvaLogo from '../../../assets/images/LOGO_NIRVA.svg';
import { CONSULTATION_COPY } from '../../../constants/consultation';
import { openSimplePracticeClientPortal } from '../../../utils/simplePractice';

export const HERO_CONTENT = {
  overHeading: 'Our Practitioners',
  heading:
    'Compassionate, IIH-Trained Professionals Dedicated To Ethical, Client-Centered Practice.',
  subtext:
    'At Nirva, you set the pace. Our certified practitioners meet you online with\npresence, discernment, and steady guidance—so you can pursue\nmeaningful change with clarity and confidence.',
  containedButtonText: CONSULTATION_COPY.startWith,
};

export const WHAT_SETS_US_APART = {
  title: 'What Sets Our Team Apart',
  cards: [
    {
      title: 'Certified & IIH-trained',
      description: 'Education through the Institute of Interpersonal\nHypnotherapy.',
      image: Certified,
      reverse: false,
    },
    {
      title: 'Compassion & Ethics',
      description: 'Grounded in empathy and ethical practice',
      image: Compassion,
      reverse: true,
    },
    {
      title: 'Personalized Approach',
      description: 'Sessions tailored to your goals and preferences.',
      image: Personalized,
      reverse: false,
    },
    {
      title: 'Support Between Sessions',
      description: 'Complimentary resources to sustain your\nmomentum.',
      image: Support,
      reverse: true,
    },
  ],
  bottomText:
    'While every experience is unique, common reflections include a quieter\nmind, clearer direction, and practical tools you can use right away.',
  buttonText: CONSULTATION_COPY.book,
};

export const CLIENT_JOURNEY = [
  { id: 1, titleTop: 'Intake Questionnaire', layout: 'textTop' },
  { id: 2, titleBottom: CONSULTATION_COPY.label, layout: 'textBottom' },
  { id: 3, titleTop: 'Book Session', layout: 'textTop' },
  {
    id: 4,
    titleBottom: 'Client Participation Agreement',
    layout: 'textBottom',
  },
  { id: 5, titleTop: 'Session(s)', layout: 'textTop' },
  { id: 6, titleBottom: 'Follow-Up', layout: 'textBottom' },
];

export const HOW_WE_WORK = {
  title: 'How It Works',
  bottomText:
    'We respond within 24 hours on weekdays and by the next business day\nfor weekend requests.',
  buttonText: 'Learn More About Our Services',
};

export const TRAINING_CONTENT = {
  title: 'Training & Professional Standards',
  description: 'Nirva practitioners are ',
  boldText1: 'certified and trained through the Institute of Interpersonal Hypnotherapy (IIH)',
  middleText: ' and follow clear ',
  boldText2: 'ethical standards',
  endText:
    ', professional boundaries, and respectful client-led pacing. We use supportive, non-medical language and focus on practical tools aligned with your goals.',
};

export const CLIENT_PORTAL_CONTENT = {
  image: nirvaLogo,
  imageAlt: 'Nirva – Interpersonal Hypnotherapy Clinic',
  title: 'Client Portal',
  subtitle: 'Already a client?',
  description:
    'Access Nirva’s secure <b>SimplePractice Client Portal</b> to complete intake forms, review and sign documents, manage appointments, send secure messages, and join your telehealth sessions.',
  buttonText: 'Access Client Portal',
  onClick: openSimplePracticeClientPortal,
};

export const ACCESS_CLIENT_PORTAL = {
  title: 'Interested in Becoming a Practitioner?',
  textBefore:
    'If you feel called to the path of Interpersonal Hypnotherapy, we warmly welcome your interest. You may email us directly at ',
  email: 'support@mynirva.com',
  textAfter:
    ' to explore practitioner training, programs, and upcoming opportunities.',
  buttonText: 'Access Client Portal',
  onClick: openSimplePracticeClientPortal,
};
